import BaseModel from '../base/BaseModel.model';
export default class ProposalDisbursement extends BaseModel {
    public porposalId?: number;
    public amount?: number;
    public disbursementDate?: Date;
    public requestDate: Date | null = new Date();
    public deliveryDate: Date | null = new Date();
    public documentId?: number;
    public requestDateDocumentId?: number | null;
    public deliveryDateDocumentId?: number| null;
    public document: any;
    public requestDateDocument: any;
    public deliveryDateDocument: any;
    public documentContrat: any;
    public tradeNumber?:string = '';
    public requestDateNumber?:string = '';
    public deliveryDateNumber?:string = '';
    
    constructor() {
        super();
        this.init();
    }
    init() {
        this.porposalId = 0;
        this.documentId = 0;
        this.amount = 0;
        this.disbursementDate = new Date();
        this.document = null;
        this.requestDateDocument = null;
        this.deliveryDateDocument = null;
        this.documentContrat = null;
        this.requestDate = new Date();
        this.deliveryDate = new Date();
        this.tradeNumber = '';
        this.requestDateNumber = '';
        this.deliveryDateNumber = '';
        this.requestDateDocumentId = null;
        this.deliveryDateDocumentId = null;
    }
}